import { Injectable } from "@angular/core";
import { RestangularModule, Restangular } from "ngx-restangular";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class QuestionBankService {
  constructor(private restangular: Restangular, private http: HttpClient) {}

  public createQuestionBank() {
    return this.restangular.all("createQuestionBank");
  }

  public getQuestionBankData() {
    return this.restangular.one("getAllQuestionBankData");
  }

  public getQBFormData() {
    return this.restangular.one("getAllEmployeesFormData");
  }

  public getQuestionBankDetails(id) {
    return this.restangular.one("getQuestionBankDetails/" + id);
  }

  getQuestionBankDetailsJoin(id) {
    return this.restangular.one("getQuestionBankDetailsJoin/" + id);
  }

  getQuestionannireQuizDetails(id) {
    return this.restangular.one("getQuestionannireQuizDetails/" + id);
  }

  getQuestionannireAllQuizDetails(id) {
    return this.restangular.one("getQuestionannireAllQuizDetails/" + id);
  }

  getAllQuestionList(id) {
    return this.restangular.one("getQuestionannireAllQuizDetails/" + id);
  }





  public updateQuestionBank(id) {
    return this.restangular.one("updateQuestionBank/" + id);
  }

  getQuestionBankHeader(id) {
    return this.restangular.one("getQuestionBankHeader/" + id);
  }

  public updateQuestionBankHeader(id) {
    return this.restangular.one("updateQuestionBankHeader/" + id);
  }

  getQuestionAnsMcq(id) {
    return this.restangular.one("getQuestionAnsMcq/" + id);
  }

  public updateQuestionAnsMcq(id) {
    return this.restangular.one("updateQuestionAnsMcq/" + id);
  }

  public deleteQuestionAns(id) {
    return this.restangular.one("deleteQuestionAns/" + id);
  }

  public deleteQuestion(id) {
    return this.restangular.one("deleteQuestion/" + id);
  }

  public deleteQuestionBank(id) {
    return this.restangular.one("deleteQuestionBank/" + id);
  }

  public createNewQuestionBank() {
    return this.restangular.all("createNewQuestionBank");
  }

  public updateMainQuestions() {
    return this.restangular.all("updateMainQuestions");
  }

  createNewWrittenQuestionBank() {
    return this.restangular.all("createNewWrittenQuestionBank");
  }

  createNewQAQuestionBank() {
    return this.restangular.all("createNewQAQuestionBank");
  }

  createNewMCQQuestionBank() {
    return this.restangular.all("createNewMCQQuestionBank");
  }





  public updateQuestionActive(id) {
    return this.restangular.one("updateQuestionActive/" + id);
  }
}




// WEBPACK FOOTER //
// /app/src/app/services/question-bank.service.ts